import Cookies from 'js-cookie';

/* eslint no-param-reassign: "error" */
function addClass(el, className) {
  if (el.classList) el.classList.add(className);
}

function acceptCookie() {
  const body = document.querySelector('body');
  addClass(body, 'hideCookieBanner');

  if (!Cookies.get('COOKIES_ACCEPTED')) {
    Cookies.set('COOKIES_ACCEPTED', 'OK', { expires: 365 });
  }
}

const cookieBanner = () => {
  const banner = document.querySelector('[js-cookie-banner]');
  if (!banner) {
    return;
  }

  const agreeButton = document.querySelector('[js-cookie-banner-button]');
  if (agreeButton) agreeButton.addEventListener('click', acceptCookie);
};

export default cookieBanner;
